import { Container, Row, Col } from 'react-bootstrap';

const About = () => {
  return (
    <Container>
      <h1 className="mb-4">About East London Brass</h1>
      
      <Row>
        <Col>
          {/* Full Band Image */}
          <div className="text-center mb-4">
                        <img
              src="./images/band/full-band.jpg"
              alt="East London Brass Band"
              className="img-fluid rounded"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>

          <div className="mb-4">
            <h2>Our Story</h2>
            <p>
              East London Brass is a championship section brass band based in Walthamstow, East London. The band has a proud and vibrant history rooted in musical excellence, community spirit, and resilience.
            </p>
            
            <p>
              The band's origins trace back to the early 1900s, when it began life under various guises as part of the East End's rich tradition of brass music-making. Over the decades, through mergers, name changes, and changes in leadership, the band evolved — always staying true to its core values of musical integrity, accessibility, and community engagement.
            </p>
            
            <p>
              The name East London Brass was officially adopted in 2000, marking a fresh chapter for the band as it established itself as a leading ensemble in the region. Under the direction of conductor Jayne Murrill, who took up the baton in 2005, the band has grown in both ambition and musical capability.
            </p>
            
            <p>
              Jayne brought a clear vision to East London Brass: to challenge the band artistically while building a welcoming, inclusive environment for musicians of all backgrounds. Her leadership has seen the band rise steadily through the ranks, with notable performances at national contests and acclaimed concert appearances across London and beyond, ultimately leading to the band winning the London and Southern Counties Championship Section title in 2025.
            </p>
            
            <p>
              Over the years, East London Brass has consistently combined contest success with community engagement. From church concerts and outdoor summer events to collaborations with local schools and charities, the band plays a vital role in keeping brass music alive and thriving in East London. The band's annual sell-out performance of "The Snowman" is testament to this.
            </p>
          </div>

          <div className="mb-4">
            <h2>Rehearsals</h2>
            <p>
              We rehearse every Thursday evening from 7:45pm to 10pm at Walthamstow United Reformed Church, 58 Orford Rd, London E17 9QU, United Kingdom.
            </p>
          </div>

          <div className="mb-4">
            <h2>Our Values</h2>
            <ul>
              <li>Musical Excellence</li>
              <li>Community Engagement</li>
              <li>Cultural Heritage</li>
              <li>Innovation and Creativity</li>
              <li>Inclusivity and Diversity</li>
            </ul>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default About; 